<template>
    <v-data-table fixed-header :items-per-page=-1 hide-default-footer single-select sort-by="timeStamp" :sort-desc="true"
        :height="kioskAnalyticsDimension.qnaAnalyticsheight" :loading="loading" :headers="analysisHeader"
        :items="analysisList"  item-key="id" >
        <template v-slot:item.transcript="{ item }">
            {{ item.transcript | trimLength }}
        </template>
        <template v-slot:item.result="{ item }">
            {{ item.result | trimLength }}
        </template>        
        <template v-slot:item.timeStamp="{ item }">
            {{ item.timeStamp | formatDateFromNow }}
        </template>
    </v-data-table>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex';

export default {
    name: 'qnaAnalytics',
    props: {
        analysisList: Array,
        loading: Boolean,
    },
    data() {
        return {
            expanded: [],
            analysisHeader: [
                { text: 'Question Asked', align: 'start', value: 'transcript' },
                { text: 'Top Response Question', value: 'transcript' },
                { text: 'Top Response Answer', value: 'result' },
                { text: 'Confidence Score', align: '', value: '-' },
                { text: 'TimeStamp', value: 'timeStamp' }
            ],
        }
    },
    computed: {
        viewPortHeight() {
            return window.innerHeight
        },
        ...mapGetters(['kioskAnalyticsDimension'])
    },
    methods: {
        getColor(object) {
            let score;
            if ('score' in object) {
                score = object.score
            } else {
                console.log('Object: ', object)
                score = object.confidenceScore * 100
            }
            if (score >= 76) {
                return 'success';
            }
            else if (score >= 60) {
                return 'amber';
            }
            else {
                return 'error';
            }
        },
    },
    filters: {
        formatDate(val) {
            if (!val) { return '-' }
            return moment(val).format('L')
        },
        formatDuration(val) {
            if (!val) { return '-' }
            return moment(val).format('mm:ss')
        },
        formatTime(val) {
            if (!val) { return '-' }
            return moment(val).format('LT')
        },
        formatStringTime(val) {
            if (!val) { return '-' }
            return moment(val).format('LTS')
        },
        formatDateFromNow(val) {
            if (!val) { return '-' }
            return moment(val).fromNow();
        },
        trimLength(val) {
            if (typeof val !== 'string') return val
            if (val === null) return val
            if (val === '') return val
            if (val.length <= 100) { return val }
            return `${val.substring(0, 50)}...`
        }
    },
}
</script>
